"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatError = void 0;
var condition_type_1 = require("./condition-type");
var property_1 = require("./property");
var condition_1 = require("./condition");
var FormatError = /** @class */ (function () {
    function FormatError(format, message, invalidValue) {
        if (FormatError.ConditionType === null) {
            FormatError.ConditionType = new condition_type_1.ErrorConditionType("FormatError", "The value is not properly formatted.");
        }
        this.format = format;
        this.messageTemplate = message;
        this.invalidValue = invalidValue;
    }
    FormatError.prototype.createCondition = function (target, prop) {
        var _this = this;
        return new condition_1.Condition(FormatError.ConditionType, function () { return _this.messageTemplate.replace("{property}", property_1.evaluateLabel(prop, target)); }, target, this.format, [prop]);
    };
    FormatError.prototype.toString = function () {
        return this.invalidValue;
    };
    FormatError.ConditionType = null;
    return FormatError;
}());
exports.FormatError = FormatError;
